/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Reset_AllInputs */

const en_filter_reset_all = /** @type {(inputs: Filter_Reset_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear search and filters`)
};

const de_filter_reset_all = /** @type {(inputs: Filter_Reset_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche und Filter zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Clear search and filters" |
*
* @param {Filter_Reset_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_reset_all = /** @type {((inputs?: Filter_Reset_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Reset_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_reset_all(inputs)
	return en_filter_reset_all(inputs)
});